export const RightFilledArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_19729_12080)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 10C20 4.47715 15.5228 -6.78525e-07 10 -4.37114e-07C4.47715 -1.95703e-07 -6.78525e-07 4.47715 -4.37114e-07 10C-1.95703e-07 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10ZM5 9.375C4.65482 9.375 4.375 9.65482 4.375 10C4.375 10.3452 4.65482 10.625 5 10.625L13.5417 10.625L10.3914 13.7753C10.1473 14.0194 10.1473 14.4151 10.3914 14.6592C10.6355 14.9032 11.0312 14.9032 11.2753 14.6592L15.4419 10.4925C15.5704 10.364 15.6312 10.1936 15.6245 10.0254C15.6248 10.017 15.625 10.0085 15.625 10C15.625 9.89213 15.5977 9.79065 15.5496 9.70209C15.5375 9.67995 15.5242 9.65862 15.5097 9.6382C15.4876 9.6071 15.4627 9.57812 15.4354 9.55161L11.2753 5.39149C11.0312 5.14741 10.6355 5.14741 10.3914 5.39149C10.1473 5.63557 10.1473 6.03129 10.3914 6.27537L13.491 9.375L5 9.375Z"
          fill="white"
          opacity="0.7"
        />
      </g>
      <defs>
        <clipPath id="clip0_19729_12080">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
